import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { API_BASE_URL } from './config';
import {
  MACHINE_DIAGNOSIS_AXES,
  getMachineThresholdDiagnosis
} from './frfBaseline';
import "./style.css";

const MachineManagement = () => {
  //檢視所有沒被清除的LocalStorage
  /*const allLocalStorage = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    allLocalStorage[key] = localStorage.getItem(key);
  }
  console.table(allLocalStorage);*/

  //除了我指定的，其他LocalStorage都清除
  Object.keys(localStorage).forEach((key) => {
    if (!['role', 'username', 'isLoggedIn', 'department'].includes(key)) {
      localStorage.removeItem(key);
    }
  });

  const [selectedOption, setSelectedOption] = useState("全部機台");
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [uniqueModels, setUniqueModels] = useState([]);

  const navigate = useNavigate();
  const handleCreateMachine = () => {
    navigate('/machine-create');
  };

  const userRole = localStorage.getItem('role');

  useEffect(() => {
    const fetchData = async () => {
      const username = localStorage.getItem('username') || '未知使用者';
      try {
        const response = await axios.get(`${API_BASE_URL}/getdata/formData`, {
          headers: { 'x-username': username }
        });
        setData(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleMachineInfo = (machine, id) => {
    const tempdata = machine;
    navigate(`/machine-info/${id}`, { state: { tempdata } });
  };

  /* tempdata、fixeddata 源頭 */
  const handleFrequencyResponse = (machine, id) => {
    const tempdata = machine;
    const filteredData = data.filter(machine =>
      machine.machineModel.split('-')[0] === tempdata.machineModel.split('-')[0]
    );
    const fixeddata = filteredData.length > 0 ? filteredData[0] : tempdata;
    navigate(`/solo-frequency-response-function-x/${id}`, { state: { tempdata, fixeddata } });
  };

  const handleDeleteMachine = async (id) => {
    try {
      await axios.post(`${API_BASE_URL}/deleteFormData`, { id });
      setData(data.filter((machine) => machine._id !== id));
      console.log(`Machine with id ${id} deleted successfully`);
    } catch (error) {
      console.error(`Error deleting machine with id ${id}:`, error);
    }
  };

  useEffect(() => {
    const models = [...new Set(data.map(machine => machine.machineModel))];
    setUniqueModels(models);
  }, [data]);

  const filteredData = selectedOption === "全部機台"
    ? data
    : data.filter((machine) => machine.machineModel === selectedOption);

  const filteredAndSearchedData = filteredData.filter((machine) => {
    const company = machine.company ? machine.company.toLowerCase() : '';
    const machineModel = machine.machineModel ? machine.machineModel.toLowerCase() : '';
    const machineForm = machine.machineForm ? machine.machineForm.toLowerCase() : '';
    const controllerType = machine.controllerType ? machine.controllerType.toLowerCase() : '';
    const location = machine.measurementLocation ? machine.measurementLocation.toLowerCase() : '';

    return (
      company.includes(searchTerm.toLowerCase()) ||
      machineModel.includes(searchTerm.toLowerCase()) ||
      machineForm.includes(searchTerm.toLowerCase()) ||
      controllerType.includes(searchTerm.toLowerCase()) ||
      location.includes(searchTerm.toLowerCase())
    );
  });

  const [sortOrder, setSortOrder] = useState(null);
  const handleSortByModel = () => {
    setSortOrder(prev => {
      if (prev === null) return "asc";
      return prev === "asc" ? "desc" : "asc";
    });
  };

  const sortedData = React.useMemo(() => {
    if (!sortOrder) return filteredAndSearchedData;
    return [...filteredAndSearchedData].sort((a, b) => {
      if (!a.machineModel) return 1;
      if (!b.machineModel) return -1;
      if (sortOrder === "asc") {
        return a.machineModel.localeCompare(b.machineModel, 'zh-Hant');
      } else {
        return b.machineModel.localeCompare(a.machineModel, 'zh-Hant');
      }
    });
  }, [filteredAndSearchedData, sortOrder]);

  const thresholdDiagnosisById = React.useMemo(() => {
    const diagnosisMap = new Map();
    data.forEach((machine) => {
      diagnosisMap.set(machine._id, getMachineThresholdDiagnosis(data, machine));
    });
    return diagnosisMap;
  }, [data]);

  const formatDiagnosisTitle = (diagnosis) => {
    if (!diagnosis) return '閾值判斷：未判定';
    const axisSummary = MACHINE_DIAGNOSIS_AXES
      .map((axis) => `${axis}: ${diagnosis.axesDetails?.[axis]?.status || '未判定'}`)
      .join(' / ');
    return `閾值判斷：${axisSummary}`;
  };

  const getDiagnosisBadgeClass = (result) => {
    if (result === 'GO') return 'machine-diagnosis-badge machine-diagnosis-go';
    if (result === 'NG') return 'machine-diagnosis-badge machine-diagnosis-ng';
    return 'machine-diagnosis-badge machine-diagnosis-pending';
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <div>
      <div style={{ height: '35px', width: '100%' }}></div>
      <nav aria-label="breadcrumb">
        <ol className="d-flex breadcrumb" style={{ width: '80%', margin: '0 auto' }}>
          <li
            className="breadcrumb-item"
            aria-current="page"
            style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}
          >
            機台資料庫
          </li>
        </ol>
      </nav>
      <div style={{ height: '35px', width: '100%' }}></div>
      <form className="d-flex flex-wrap mb-3" style={{ height: 'auto', width: '80.9%', margin: '0 auto' }} onSubmit={handleSearchSubmit}>
        <div className="me-auto p-2">
          <div className="d-flex bd-highlight">
            <span style={{ fontSize: '16px', display: 'flex', alignItems: 'center', minWidth: '80px' }}>型號選擇：</span>
            <div>
              <select
                className="form-select"
                style={{ width: '150px' }}
                value={selectedOption}
                onChange={handleSelectChange}
              >
                <option value="全部機台">全部機台</option>
                {uniqueModels.map(model => (
                  <option key={model} value={model}>{model}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="p-2">
          <input
            type="search"
            className="form-control"
            placeholder="請輸入關鍵字"
            value={searchTerm}
            onChange={handleSearchChange}
            style={{ width: '150px', minWidth: '150px', maxWidth: '150px' }}
          />
        </div>

        <div className="p-2">
          <button
            className="btn-create btn-primary"
            type="button"
            title="匯入資料"
            onClick={handleCreateMachine}
          >
            +
          </button>
        </div>
      </form>

      <div>
        <div
          className="table-responsive"
          style={{
            maxHeight: '720px',
            maxWidth: '80%',
            overflowY: 'auto',
            overflowX: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <table className="table table-striped text-center table-hover table-bordered">
            <thead className="custom-thead">
              <tr>
                <th>#</th>
                <th>廠商</th>
                <th>
                  型號
                  <button
                    style={{
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                      marginLeft: "5px"
                    }}
                    onClick={handleSortByModel}
                    title="排序"
                    type="button"
                  >
                    {sortOrder === "asc" ? (
                      <i className="bi bi-sort-down-alt"></i>
                    ) : sortOrder === "desc" ? (
                      <i className="bi bi-sort-down"></i>
                    ) : (
                      <i className="bi bi-arrow-down-up"></i>
                    )}
                  </button>
                </th>
                <th>機台型式</th>
                <th>控制器類型</th>
                <th>地點</th>
                <th>X軸行程</th>
                <th>Y軸行程</th>
                <th>Z軸行程</th>
                <th>檢測結果</th>
                <th>功能</th>
              </tr>
            </thead>
            <tbody>


              {sortedData.map((machine, index) => {
                const diagnosis = thresholdDiagnosisById.get(machine._id);
                const diagnosisResult = diagnosis?.overallResult;

                return (
                  <tr key={machine._id}>
                    <td>{index + 1}</td>
                    <td>{machine.company}</td>
                    <td>{machine.machineModel}</td>
                    <td>{machine.machineForm}</td>
                    <td>{machine.controllerType}</td>
                    <td>{machine.measurementLocation}</td>
                    <td>{machine.travelX}</td>
                    <td>{machine.travelY}</td>
                    <td>{machine.travelZ}</td>
                    <td>
                      <span
                        className={getDiagnosisBadgeClass(diagnosisResult)}
                        title={formatDiagnosisTitle(diagnosis)}
                      >
                        {diagnosisResult || '未判定'}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <button
                          className="btn-view"
                          onClick={() => handleMachineInfo(machine, index + 1)}
                        >
                          檢視
                        </button>
                        <button
                          className="btn-view"
                          onClick={() => handleFrequencyResponse(machine, index + 1)}
                        >
                          函數
                        </button>
                        {userRole === 'admin' && (
                          <button className="btn-delete" onClick={() => handleDeleteMachine(machine._id)}>
                            刪除
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ height: '60px', width: '100%' }}></div>
    </div>
  );
};

export default MachineManagement;
